import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ProductApiType } from 'features/managePlan/slice';

import {
  CheckoutInitiatedFrom,
  CheckoutState,
  HiringCheckoutInitiatedFrom,
} from '../../types';

export const SLICE_NAME = 'checkout';

const initialState: CheckoutState = {
  status: 'idle',
  error: null,
  productInfo: undefined,
  initiatedFrom: null,
  isOpen: false,
  onSuccess: undefined,
};

interface StartCheckoutPayload {
  initiatedFrom: CheckoutInitiatedFrom | HiringCheckoutInitiatedFrom;
  productInfo?: ProductApiType[keyof ProductApiType];
  onSuccess?: () => Promise<void>;
}

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    startCheckout: (state, action: PayloadAction<StartCheckoutPayload>) => {
      state.status = 'in_progress';
      state.initiatedFrom = action.payload.initiatedFrom;
      state.productInfo = action.payload.productInfo;
      state.onSuccess = action.payload.onSuccess;
      state.error = null;
      state.isOpen = true;
    },

    checkoutSuccess: state => {
      state.status = 'success';
      state.error = null;
    },

    checkoutFailure: (state, action: PayloadAction<string>) => {
      state.status = 'failure';
      state.error = action.payload;
    },

    checkoutDismissed: state => {
      state.status = 'dismissed';
      state.initiatedFrom = null;
      state.productInfo = undefined;
      state.isOpen = false;
    },

    resetCheckout: () => initialState,
  },
});

export const { actions, reducer } = slice;

export const {
  startCheckout,
  checkoutSuccess,
  checkoutFailure,
  checkoutDismissed,
  resetCheckout,
} = actions;
